module.exports = require("babel-runtime/helpers/classCallCheck");


/*****************
 ** WEBPACK FOOTER
 ** external "babel-runtime/helpers/classCallCheck"
 ** module id = 1
 ** module chunks = 0
 **/